export const GET_STUDENT_PROFILE_DATA = "GET_STUDENT_PROFILE_DATA";

export const RESET_STUDENT_DETAILS = "RESET_STUDENT_DETAILS";

export const RESET_DETAILS_RESULT = "RESET_DETAILS_RESULT"


export const  RESET_STUDENT_PASSWORD = "RESET_STUDENT_PASSWORD";